import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SeoService } from "src/app/services/seo.service";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Component({
  selector: "v2m-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit {
  apiUrl = "https://api.video2manual.de/api/newsletters/register";
  salutation = "";
  lastname = "";
  firstname = "";
  email = "";
  phone = "";
  company = "";
  privacy = false;
  isSending = false;
  isSended = false;

  constructor(private http: HttpClient, private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateTitle("video2manual - Kontakt");
    this.seo.updateKeywords("Kontakt,Newsletter");
  }

  send() {
    const request = {
      Email: this.email,
      Salutation: this.salutation,
      FirstName: this.firstname,
      LastName: this.lastname,
      Phone: this.phone,
      CompanyName: this.company,
      RegistrationMethod: "Website",
    };

    this.isSending = true;

    this.http.post(this.apiUrl, request, httpOptions).subscribe((_) => {
      this.isSending = false;
      this.isSended = true;
    });
  }
}
